import { useState } from 'react';
import { resetPassword } from '../../api/Auth';
import { Link, useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';

const { REACT_APP_ClientKey, REACT_APP_VERSION } = process.env;

function ForgotPassword() {
  const navigate = useNavigate();
  const clientKey = `${REACT_APP_ClientKey}`;

  //States

  const [email, setEmail] = useState('');

  const [alertMessage, setAlertMessage] = useState('');
  const [noError, setNoError] = useState(true);
  const [captcha, setCaptcha] = useState(true);

  //Functions

  //Handles the change in inputted password
  const handleInputChange = (event: any) => {
    event.preventDefault();
    const target = event.target;
    setEmail(event.target.value);
  };

  //Handles the submit
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    //Validations for the email
    if (regex.test(email)) {
      setNoError(false);
      try {
        const response = await resetPassword(email);
        if (response) {
          navigate('/signin');
        }
      } catch (error) {
        console.log(error);
      }
      setAlertMessage('');
    } else {
      setNoError(true);
      return setAlertMessage('Enter valid email');
    }
  };

  if (captcha) {
    return (
      <div>
        <div className='container'>
          <div className='row mt-5'>
            <div className='col-3'>
              <img src='/assets/Logos/AppIcon.png' />
            </div>
            <div className='col'></div>
          </div>
          <div className='row mt-5'>
            <div className='col-4'></div>
            <div className='col'>
              <h1>Reset Password</h1>

              {alertMessage != '' && alertMessage != 'success' && (
                <div className='alert alert-danger' role='alert'>
                  {alertMessage}
                </div>
              )}
              {alertMessage === 'success' && (
                <div className='alert alert-success' role='alert'>
                  Successfully reset the password!
                </div>
              )}
              <form>
                <div className='mb-3'>
                  <label className='form-label'>Email address</label>
                  <input
                    type='email'
                    className='form-control'
                    name='email'
                    value={email}
                    onChange={handleInputChange}
                  />
                </div>
                <Link to='/signin' className='btn btn-danger me-3'>
                  Back
                </Link>

                <button
                  type='submit'
                  className='btn btn-primary'
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </form>
            </div>
            <div className='col-4'></div>
          </div>
        </div>
        <div style={{ position: 'fixed', bottom: '0', right: '1%' }}>
          <p>v{REACT_APP_VERSION}</p>
        </div>
      </div>
    );
  } else {
    return (
      <div style={{ position: 'absolute', left: '40%', top: '40%' }}>
        <div>
          <ReCAPTCHA
            sitekey={clientKey}
            onChange={() => {
              setCaptcha(true);
            }}
          />
        </div>
      </div>
    );
  }
}

export default ForgotPassword;
